import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { StreamsPage } from '@/features/admin/streams/stream-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Streams du tenant. */
export const Route = createFileRoute('/$tenant/streams/')({ component: StreamsRoute });

function StreamsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="streams" crumbs={[{ label: t('nav.items.streams') }]}>
      <StreamsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
